import "./PlanYourBespokeJourney.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import JourneyPlanningForm from "./sections/JourneyPlanningForm";
import CircuitxProcessTrustSection from "./sections/CircuitxProcessTrustSection";
import Footer from "@/reusable_sections/Footer";
export default function PlanYourBespokeJourneyPage() {
  return <div>
      <Header />
      <HeroSection />
      <JourneyPlanningForm />
      <CircuitxProcessTrustSection />
      <Footer />
    </div>;
}